import { SvgIcon } from '@mui/material';
import { ReactComponent as WalletSVG } from "./wallet-tc.svg";

export default function IconIOSWalletTC(props) {
  return <SvgIcon {...props} component={WalletSVG} viewBox="0 0 96 34" />;
}